import React from 'react';
import styled from 'styled-components';
import CLOSE_ALERT from '../../assets/imgs/icon/close_alert.svg';
import { IconButton } from '../../GlobalComponents/IconButton';

export interface NewAlertProps {
	isOpen?: boolean;
	toggle?: React.MouseEventHandler<any>;
	children?: JSX.Element[] | JSX.Element
}

const NewAlert = ({children,
	toggle,
	...props}: NewAlertProps) => {
	return (
		<ModalContainer {...props}>
			<RootAlertContainer>
				<CloseButton onClick={toggle}>
					<IconButton
						url={CLOSE_ALERT}
						alt="close"
						width={20}
						height={20}
					/>
				</CloseButton>
				<AlertText>{children}</AlertText>
			</RootAlertContainer>
		</ModalContainer>
	);
};

export default NewAlert;

const ModalContainer = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: auto;
	z-index: 9999;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	padding: 1rem;
`;

const RootAlertContainer = styled.div`
	background-color: #ffdddd;
	position: relative;
	width: 100%;
	padding: 2rem 1rem;
	border: solid 1px #a05c62;
`;

const CloseButton = styled.div`
	border: none;
	color: #f5c6cb;
	margin-left: -0.5rem;
	margin-bottom: 0.5rem;
	position: absolute;
	top: 0.5rem;
	right: 0.5rem;
`;

const AlertText = styled.div`
	color: #a05c62;
	margin: 0;
`;
